import { useQuery } from '@tanstack/react-query';
import getApi from '@/lib/axios';
import { ExtractFnReturnType } from '@/lib/react-query';

async function getRaioxTurmas(params): Promise<any> {
  const api = await getApi();
  const { data } = await api.get<any>('/raiox/turmas/', {params});
  return data;
}

type QueryFnType = typeof getRaioxTurmas;

function useRaioxTurmas(params) {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['fetch-raiox-turmas', params],
    queryFn: () =>  getRaioxTurmas(params),
  });
}

export { useRaioxTurmas };
